<template lang='pug'>
  i.svg-icon.svg-icon-pill
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      circle(fill='#7FDBD5' cx='45.54' cy='64.751' r='4.183')
      circle(fill='#38648C' cx='55.896' cy='69.365' r='2.406')
      circle(fill='#38648C' cx='43.329' cy='52.645' r='3.981')
      circle(fill='#7FDBD5' cx='57.206' cy='58.49' r='5.018')
      circle(fill='#F28B74' cx='55.373' cy='45.689' r='5.376')
      circle(fill='#F28B74' cx='45.54' cy='74.453' r='2.213')
      path(fill='#25AF9F' d='M14.662,56.71l21.119,8.747c0.779,0.321,1.672-0.048,1.994-0.827l12.107-29.229 c0.323-0.78-0.047-1.672-0.825-1.993l-21.119-8.749c-8.851-3.666-18.997,0.537-22.662,9.387l0,0 C1.609,42.896,5.812,53.044,14.662,56.71z')
      path(opacity='0.1' d='M37.775,64.63l2.982-7.199C15.814,52.687,7.439,37.944,9.391,28.075 c-1.727,1.628-3.148,3.636-4.115,5.971l0,0c-3.666,8.85,0.536,18.998,9.387,22.664l21.118,8.747 C36.56,65.78,37.452,65.409,37.775,64.63z')
      path(fill='#82C8DB' d='M85.366,56.71l-21.118,8.747c-0.779,0.321-1.673-0.048-1.995-0.827L50.146,35.401 c-0.323-0.78,0.048-1.672,0.827-1.993l21.118-8.749c8.851-3.666,18.996,0.537,22.662,9.387l0,0 C98.419,42.896,94.216,53.044,85.366,56.71z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
  },

}
</script>